import { IModifier } from '@Core/Events/EventModifiers/Modifier';
import SpineWrapperEventManager from '../Animation/SpineWrapperEventManager';
import { partitionArray } from '@Tools/PartitionArray';

export const getEventWithoutParams = (str: string): string => {
    const stringWithoutFolders = str?.includes('/') ? str.substring(str.lastIndexOf('/') + 1) : str;
    const index = stringWithoutFolders?.indexOf('#');
    return index === -1 ? stringWithoutFolders?.trim() : stringWithoutFolders?.substring(0, index).trim();
};

export const getEventFolderModifiers = (str: string): string[] => {
    const parts = str.split(SpineWrapperEventManager.MODIFIER_CHARACTER);
    const modifiers = parts.slice(0, -1);
    return modifiers;
};

export const getEventParameters = (str: string): string[] => {
    const paramRegex = /#\S+/g;
    const matches = str.match(paramRegex)?.[0];
    const parameters = matches ? matches.split(SpineWrapperEventManager.PARAMETER_CHARACTER) : [];
    if (parameters.length > 0) parameters.shift();
    return parameters;
};

export const getAllEventModifiers = (str: string): string[] => {
    const modifiers = [...getEventParameters(str), ...getEventFolderModifiers(str)];
    return modifiers;
};

export function filterEventsByModifier(
    events: string[],
    modifierCheck: (animation: string) => boolean,
    requirementCheck?: (animation: string) => boolean
): string[] {
    const [matching, nonMatching] = partitionArray(events, modifierCheck);
    if (matching.length === 0) return nonMatching;
    if (!requirementCheck) return matching;
    const filtered = matching.filter(requirementCheck);
    return filtered.length > 0 ? filtered : nonMatching;
}

export function filterEventsByModifiers(events: string[], modifiers: IModifier[]): string[] {
    let result = events;
    for (const mod of modifiers) result = filterEventsByModifier(result, mod.modifierCheck.bind(mod), mod.requirementCheck?.bind(mod));
    return result;
}

export function filterEventsByOwnModifiers(events: string[], modifiers: IModifier[]): string[] {
    const [baseEvents, eventsWithModifiers] = partitionArray(events, (event) => getAllEventModifiers(event).length === 0);

    if (eventsWithModifiers.length === 0) return baseEvents;

    const validEvents = eventsWithModifiers.filter((event) => {
        let isValid: boolean = true;
        for (const modifier of modifiers) {
            const hasThisModifier = modifier.modifierCheck(event);
            if (!hasThisModifier) continue;
            if (!modifier?.requirementCheck) continue;
            const passRequirement = modifier.requirementCheck(event);
            if (passRequirement) continue;
            else isValid = false;
        }
        return isValid;
    });

    return [...baseEvents, ...validEvents];
}
